// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhyTackRouteImport } from './routes/why-tack'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DpaRouteImport } from './routes/dpa'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as CashierRouteImport } from './routes/_cashier'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TackSlugRouteImport } from './routes/tack.$slug'
import { Route as RedeemFeedbackIdRouteImport } from './routes/redeem.$feedbackId'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CashierSelectRouteImport } from './routes/_cashier.select'
import { Route as CashierCashierCardRouteImport } from './routes/_cashier.cashier-card'
import { Route as CashierCashierRouteImport } from './routes/_cashier.cashier'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated.settings'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated.onboarding'
import { Route as AuthenticatedLocationsRouteImport } from './routes/_authenticated.locations'
import { Route as AuthenticatedFlashSaleRouteImport } from './routes/_authenticated.flash-sale'
import { Route as AuthenticatedDiscountsRouteImport } from './routes/_authenticated.discounts'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AuthenticatedTackPreviewSlugRouteImport } from './routes/_authenticated.tack-preview.$slug'
import { Route as AuthenticatedPosterSlugRouteImport } from './routes/_authenticated.poster.$slug'
import { Route as AuthenticatedAdminUsageAlertsRouteImport } from './routes/_authenticated.admin_.usage-alerts'
import { Route as AuthenticatedAdminEmailPreviewRouteImport } from './routes/_authenticated.admin_.email-preview'
import { Route as AuthenticatedLocationsIndexRouteImport } from './routes/_authenticated.locations.index'
import { Route as AuthenticatedLocationsNewRouteImport } from './routes/_authenticated.locations.new'

const WhyTackRoute = WhyTackRouteImport.update({
            id: '/why-tack',path: '/why-tack',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DpaRoute = DpaRouteImport.update({
            id: '/dpa',path: '/dpa',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const AcceptInviteRoute = AcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => rootRouteImport
          })
const CashierRoute = CashierRouteImport.update({
            id: '/_cashier',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TackSlugRoute = TackSlugRouteImport.update({
            id: '/tack/$slug',path: '/tack/$slug',getParentRoute: () => rootRouteImport
          })
const RedeemFeedbackIdRoute = RedeemFeedbackIdRouteImport.update({
            id: '/redeem/$feedbackId',path: '/redeem/$feedbackId',getParentRoute: () => rootRouteImport
          })
const RTokenRoute = RTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CashierSelectRoute = CashierSelectRouteImport.update({
            id: '/select',path: '/select',getParentRoute: () => CashierRoute
          })
const CashierCashierCardRoute = CashierCashierCardRouteImport.update({
            id: '/cashier-card',path: '/cashier-card',getParentRoute: () => CashierRoute
          })
const CashierCashierRoute = CashierCashierRouteImport.update({
            id: '/cashier',path: '/cashier',getParentRoute: () => CashierRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLocationsRoute = AuthenticatedLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedFlashSaleRoute = AuthenticatedFlashSaleRouteImport.update({
            id: '/flash-sale',path: '/flash-sale',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDiscountsRoute = AuthenticatedDiscountsRouteImport.update({
            id: '/discounts',path: '/discounts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTackPreviewSlugRoute = AuthenticatedTackPreviewSlugRouteImport.update({
            id: '/tack-preview/$slug',path: '/tack-preview/$slug',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPosterSlugRoute = AuthenticatedPosterSlugRouteImport.update({
            id: '/poster/$slug',path: '/poster/$slug',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminUsageAlertsRoute = AuthenticatedAdminUsageAlertsRouteImport.update({
            id: '/admin_/usage-alerts',path: '/admin/usage-alerts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminEmailPreviewRoute = AuthenticatedAdminEmailPreviewRouteImport.update({
            id: '/admin_/email-preview',path: '/admin/email-preview',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLocationsIndexRoute = AuthenticatedLocationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedLocationsRoute
          })
const AuthenticatedLocationsNewRoute = AuthenticatedLocationsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedLocationsRoute
          })





const AuthenticatedLocationsRouteChildren = {
  AuthenticatedLocationsNewRoute: AuthenticatedLocationsNewRoute,AuthenticatedLocationsIndexRoute: AuthenticatedLocationsIndexRoute
}

const AuthenticatedLocationsRouteWithChildren = AuthenticatedLocationsRoute._addFileChildren(AuthenticatedLocationsRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDiscountsRoute: AuthenticatedDiscountsRoute,AuthenticatedFlashSaleRoute: AuthenticatedFlashSaleRoute,AuthenticatedLocationsRoute: AuthenticatedLocationsRouteWithChildren,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedAdminEmailPreviewRoute: AuthenticatedAdminEmailPreviewRoute,AuthenticatedAdminUsageAlertsRoute: AuthenticatedAdminUsageAlertsRoute,AuthenticatedPosterSlugRoute: AuthenticatedPosterSlugRoute,AuthenticatedTackPreviewSlugRoute: AuthenticatedTackPreviewSlugRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const CashierRouteChildren = {
  CashierCashierRoute: CashierCashierRoute,CashierCashierCardRoute: CashierCashierCardRoute,CashierSelectRoute: CashierSelectRoute
}

const CashierRouteWithChildren = CashierRoute._addFileChildren(CashierRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,CashierRoute: CashierRouteWithChildren,AcceptInviteRoute: AcceptInviteRoute,DemoRoute: DemoRoute,DpaRoute: DpaRoute,FaqRoute: FaqRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,StatusRoute: StatusRoute,TermsRoute: TermsRoute,WhyTackRoute: WhyTackRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutReturnRoute: CheckoutReturnRoute,RTokenRoute: RTokenRoute,RedeemFeedbackIdRoute: RedeemFeedbackIdRoute,TackSlugRoute: TackSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)